import { render, staticRenderFns } from "./segmentosConfiguracoesEditar.vue?vue&type=template&id=51214e3f&scoped=true&"
import script from "./segmentosConfiguracoesEditar.vue?vue&type=script&lang=js&"
export * from "./segmentosConfiguracoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./segmentosConfiguracoesEditar.vue?vue&type=style&index=0&id=51214e3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51214e3f",
  null
  
)

export default component.exports